import Icon, {iconTypes} from "../../../common/components/Icon.jsx";

import DeliveringDate from "../deliveringDate.jsx";
import DeliveringStatus from "../deliveringStatus";
import {HISTORY_TYPES} from "../../actions/history.js";
import LastOrderModal from "./lastOrderModal.jsx";
import {Localization} from "../../../common/util/localization.jsx";
import ProductsDisplay  from "./productDisplay.jsx";
import PropTypes from "prop-types";
import React from "react";
import ResponsiveColumn from "../../../common/components/ResponsiveColumn.jsx";
import ResponsiveRows from "../../../common/components/ResponsiveRows.jsx";
import moment from "moment";

export default class LastDeliveryCard extends React.PureComponent {
    constructor(props){
        super(props);

        this.onClickCreateInvoiceClaim = this.onClickCreateInvoiceClaim.bind(this);
        this.onCLickInvoice = this.onCLickInvoice.bind(this);
        this.closeOrderModal = this.closeOrderModal.bind(this);
    }

    onClickCreateInvoiceClaim() {
        const {
            history,
            lastDelivery,
            clearClaim,
        } = this.props;
        clearClaim();
        history.push(`/history/claim/${lastDelivery.invoiceId}/invoice`);
    }
    onCLickInvoice() {
        const {
            downloadHistoryPdf,
            lastDelivery,
            signedInAs,
            token,
            localization,
            deviceType,
            orderFeeLimits,
            orderVolumeDiscounts,
            setModal,
            height,
        } = this.props;

        if(lastDelivery.invoiceId != null)
        {
            downloadHistoryPdf(token, signedInAs, {
                historyType: HISTORY_TYPES.INVOICES,
                historyPdfKey: lastDelivery.invoiceId,
            });
        }
        else
        {
            // Displays the contents of the last order which is not invoiced
            this.props.setModal(<LastOrderModal localization={localization} deviceType={deviceType} activeOrder={lastDelivery} onCloseModal={this.closeOrderModal} width={460} orderFeeLimits={orderFeeLimits} orderVolumeDiscounts = {orderVolumeDiscounts} setModal={setModal} height={height}/>);
        }
       
    }

    closeOrderModal(event) {
        event.stopPropagation();
        event.preventDefault();
        
        this.props.setModal(null);
    }

    render(){
        const {
            localization,
            lastDelivery,
            lastDeliveryProductList,
        } = this.props;
        let deliveredDate = "";
        let deliveredTime = "";
        const status = lastDelivery ? lastDelivery.status : "";
        const hasInvoice = lastDelivery.invoiceId != null;
        const totalOrderLines = lastDelivery.orderLines ? lastDelivery.orderLines.length : 0;
        if( lastDelivery ) {
            deliveredDate = lastDelivery.deliveryDate ? moment(lastDelivery.deliveryDate).format("MMMM DD") : "";
            deliveredTime = lastDelivery.deliveryDate ? moment(lastDelivery.deliveryDate).format(`[${localization.text("time","at")}] HH:mm`) : "";
        }
        const deliveryDelayDesc = lastDelivery.delay ? lastDelivery.delay.delayedDescription : null;

        return (
            <div className="card-default">
                <div style={{display:"flex"}} >
                    <div className="dashboard-card-left">
                        <label className="dashboard-card-header">
                            {localization.text("dashboard","lastDelivery")}
                        </label>
                        <ResponsiveRows gutters={false}>
                            <ResponsiveColumn xs={12}>
                                <div style={{paddingTop:"16px"}}>
                                    <DeliveringStatus localization={localization} isDelivered={true} status={status} />
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={12}>
                                <div style={{paddingTop:"16px"}}>
                                    <DeliveringDate localization={localization} deliveryDate={deliveredDate} deliveryTime={deliveredTime} deliveryDelayDesc={deliveryDelayDesc} delivery={lastDelivery} />
                                </div>
                            </ResponsiveColumn>
                        </ResponsiveRows>
                        {totalOrderLines>0 && (
                            <div className="order-lines">
                                <div className="text-bottom">
                                    {localization.text("dashboard","xOrderLines",{count:totalOrderLines})}
                                </div>
                            </div>
                        )}
                    </div>
                    <ProductsDisplay localization={localization} useText={["dashboard","xLines"]} products={lastDeliveryProductList || []} count={0}/>
                </div>
                <div className="hr"/>
                <div className="dashboard-card-bottom">
                    <ResponsiveRows gutters={false}>
                        <ResponsiveColumn xs={12} lg={6}>
                            <button className={"btn icon block"} onClick={this.onCLickInvoice} >
                                <Icon type={iconTypes.listInvoice}/>
                                {localization.text("dashboard", hasInvoice ? "seeInvoice": "seeOrderLines")}
                            </button>
                        </ResponsiveColumn>
                        <ResponsiveColumn xs={12} lg={6}>
                            <button className={"btn primary block"} onClick={this.onClickCreateInvoiceClaim}  disabled={!hasInvoice}>
                                {localization.text("dashboard","makeClaim")}
                            </button>
                        </ResponsiveColumn>
                    </ResponsiveRows>
                </div>
            </div>
        );
    }
}
LastDeliveryCard.propTypes = {
    deviceType: PropTypes.string.isRequired,
    localization: Localization.propTypes.isRequired,
    lastDelivery: PropTypes.object,
    lastDeliveryProductList: PropTypes.array,
    history: PropTypes.object.isRequired,
    downloadHistoryPdf: PropTypes.func.isRequired,
    signedInAs: PropTypes.string.isRequired,
    token: PropTypes.string.isRequired,
    clearClaim: PropTypes.func.isRequired,
    setModal: PropTypes.func.isRequired,
    orderFeeLimits: PropTypes.array.isRequired, 
    orderVolumeDiscounts: PropTypes.array.isRequired,
    height: PropTypes.number.isRequired,
};